import React from "react";
import { object, func } from "prop-types";
import { useTranslation } from "@lib/i18n";

import Typography from "../shared/Typography";

import gtm from "@gtm/core";
import { useScrollToView } from "@hooks/useScrollToView";
import { testDriveLinkEvent } from "@gtm/events/testdrive";

const TitleContainer = ({ typesContainerRef, setIsTypeExplanationOpen }) => {
  const { t } = useTranslation();
  const scrollToView = useScrollToView();

  const scrollToTypeExplanation = () => {
    scrollToView(typesContainerRef);
    setIsTypeExplanationOpen(true);
    gtm.fire(testDriveLinkEvent());
  };

  return (
    <div>
      <h1 className="mb-4 text-2xl font-extrabold uppercase text-primaryDark md:text-5xl">
        {t("testDrive.title")}
      </h1>
      <Typography className="text-sm text-black ">
        {t("testDrive.description")}{" "}
        <span
          className="underline whitespace-nowrap cursor-pointer text-primaryDark hover:text-primaryOrange"
          onClick={scrollToTypeExplanation}
        >
          {t("testDrive.typesLink")}
        </span>
      </Typography>
      <Typography className="my-4 text-lg uppercase font-extrabold text-primaryDark lg:text-2xl">
        {t("testDrive.subtitle")}
      </Typography>
    </div>
  );
};

TitleContainer.propTypes = {
  typesContainerRef: object,
  setIsTypeExplanationOpen: func.isRequired,
};

export default TitleContainer;
